<nav class="flex items-center flex-wrap bg-blue2 h-[65px]">
  <a
    [routerLink]="(userData | async) ? '/customer' : '/home'"
    class="flex items-center mr-12 icon-main mt-1.5 mb-1.5 ml-2 hidden md:block cursor-pointer hover:opacity-80 transition-all ease-in-out">
    <img class="h-[55px]" src="../../assets/svg/pvc-logo-color.svg" alt="PVSmartClick logo">
  </a>
  <div class="text-color-white flex items-stretch content-center h-full overflow-auto whitespace-nowrap"
       *transloco="let t; read: 'navigation'">
    <ng-container *ngFor="let navigationItem of navigationItems$ | async">
      <!-- t(home, home-calculator, pricing, contact_us) -->
      <!-- t(customer, advanced-calculator, saved-power-plants, offer-requests, my-prices, business-dashboard) -->
      <!-- t(contractor) -->
      <!-- t(statistics, public-prices, parameters, users, banks, dashboard) -->
      <ng-template
        [pscRoleAccess]="navigationItem.roles"
        [includeNotLoggedInUsers]="navigationItem.visibleForNotLoggedIn">
        <h2>
          <a
            href="#responsive-header"
            class="flex items-center justify-center hover:bg-blue3 hover:text-blue1 h-full pr-4 pl-4 transform transition duration-200"
            routerLink="{{navigationItem.route}}"
            routerLinkActive="bg-blue3">
            {{ t(navigationItem.nameKey) }}
          </a>
        </h2>
      </ng-template>
    </ng-container>
  </div>
</nav>
